import React from 'react';
import { DndContext, closestCenter } from '@dnd-kit/core';
import { arrayMove, SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { FaGripVertical } from 'react-icons/fa';

// Importe os widgets que o modal utiliza
import TermometroHumor from '../Colaborador/TermometroHumor';
import PlanoDesenvolvimentoIndividual from '../Colaborador/PlanoDesenvolvimentoIndividual';
import HistoricoSalarial from '../Colaborador/HistoricoSalarial';

// -- Componentes internos copiados de PainelLideranca.js --

const SortableWidget = ({ widgetId, title, className, children }) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: widgetId });
    const style = { transform: CSS.Transform.toString(transform), transition };
    return (
      <div ref={setNodeRef} style={style} {...attributes}>
        <section className={`colaborador-section ${className} card`}>
          <div className="card-header-draggable">
            <h3>{title}</h3>
            <button className="drag-handle" {...listeners} aria-label="Arrastar para reordenar">
              <FaGripVertical />
            </button>
          </div>
          <div className="card-body-content">{children}</div>
        </section>
      </div>
    );
};

const WIDGET_CONFIG_MODAL = {
    humor: { title: 'Termômetro de Humor', className: 'humor-section' },
    pdi: { title: 'Plano de Desenvolvimento Individual (PDI)', className: 'pdi-section' },
    salario: { title: 'Histórico de Recebimento', className: 'historico-salarial-section' },
};

// -- O componente principal do modal --
// MUDANÇA: 'onDragEnd' foi renomeado para 'onOrderChange' para maior clareza
const DetalhesModal = ({ subordinado, onClose, widgetOrder, onOrderChange }) => {
    if (!subordinado) return null;

    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (over && active.id !== over.id) {
            const oldIndex = widgetOrder.indexOf(active.id);
            const newIndex = widgetOrder.indexOf(over.id);
            const newOrder = arrayMove(widgetOrder, oldIndex, newIndex);
            onOrderChange(newOrder); // Usa a prop para notificar a mudança
        }
    };

    const renderWidgetById = (widgetId) => {
        switch(widgetId) {
            case 'humor': return <TermometroHumor historicoHumor={subordinado.privateData?.termometroHumor || []} userId={subordinado.uid} isReadOnly={true} />;
            case 'pdi': return <PlanoDesenvolvimentoIndividual pdiData={subordinado.privateData?.pdi} userId={subordinado.uid} isReadOnly={true} />;
            case 'salario': return <HistoricoSalarial historico={subordinado.privateData?.historicoSalarial || []} />;
            default: return null;
        }
    };
    return (
        <div className="modal-backdrop">
            <div className="modal-content" style={{maxWidth: '80%', width: '1200px'}}>
                <div className="modal-header"><h4 className="mb-0">Detalhes de: {subordinado.publicData.name}</h4><button onClick={onClose} className="btn-close" aria-label="Fechar"></button></div>
                <div className="modal-body">
                    <p className="text-muted small text-center mb-4">Arraste os cards para reordenar a visualização. Esta ordem será salva.</p>
                    <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
                        <SortableContext items={widgetOrder} strategy={verticalListSortingStrategy}>
                            <div className="colaborador-grid">
                                {widgetOrder.map(widgetId => (
                                    <SortableWidget key={widgetId} widgetId={widgetId} title={WIDGET_CONFIG_MODAL[widgetId]?.title} className={WIDGET_CONFIG_MODAL[widgetId]?.className}>
                                        {renderWidgetById(widgetId)}
                                    </SortableWidget>
                                ))}
                            </div>
                        </SortableContext>
                    </DndContext>
                </div>
                <div className="modal-actions"><button onClick={onClose} className="btn btn-secondary">Fechar</button></div>
            </div>
        </div>
    );
};

export default DetalhesModal;